import {GraphNode} from "#graph/nodes/graph/graph-node"
import type {GraphNodeDefinition} from "#graph/nodes/graph/types"
import type {NodeParameters} from "#graph/nodes/base/types"
import {z} from "zod/v4-mini"

const serializedNodeDefinition: GraphNodeDefinition<unknown, NodeParameters, NodeParameters> = {
    nodeClass: "SerializedNode",
    validation: {
        parameters: z.record(z.string(), z.unknown()),
        returns: z.unknown(),
    },
}

// Placeholder GraphNode produced by `deserializeGraphNode(g, {structureOnly: true})`. Walks the
// serialized tree without instantiating the original registered classes (which on the server side
// would pull in the entire template-nodes runtime). Consumers read `nodeClass` to dispatch by the
// original class name and inspect the raw `parameters` directly.
export class SerializedNode extends GraphNode<unknown, unknown, NodeParameters, NodeParameters> {
    public readonly originalNodeClass: string
    public readonly originalVersion: number

    constructor(options: {originalNodeClass: string; originalVersion: number; parameters: NodeParameters}) {
        super({parameters: options.parameters, disableValidation: true})
        this.originalNodeClass = options.originalNodeClass
        this.originalVersion = options.originalVersion
    }

    public override get definition() {
        return serializedNodeDefinition
    }

    public override get nodeClass() {
        return this.originalNodeClass
    }

    public override get nodeVersion() {
        return this.originalVersion
    }
}
